import { FC } from "react";
import { useFormikContext } from "formik";
import { FormProps } from "@dashboard/modules/products/types/product-form.types";
import { isService } from "@dashboard/modules/products/utils/service-form.utils";
import Product from "../views/product/product";
import Service from "../views/service/service";

const ProductFormIndex: FC = () => {
  const { values } = useFormikContext<FormProps>();

  return isService(values) ? <Service /> : <Product />;
};

export default ProductFormIndex;
